import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  FormControl,
  FormLabel,
  Select as MuiSelect,
  InputBase,
  FormHelperText,
} from "@material-ui/core"
import Chevron from "./chevron.svg"

const useStyles = makeStyles(theme => {
  const visuallyHidden = {
    //https://a11yproject.com/posts/how-to-hide-content/
    position: "absolute !important",
    height: "1px",
    width: "1px",
    overflow: "hidden",
    clip: "rect(1px 1px 1px 1px)" /* IE6, IE7 */,
    // eslint-disable-next-line
    clip: "rect(1px, 1px, 1px, 1px)",
    whiteSpace: "nowrap" /* added line */,
  }
  return {
    root: {
      textAlign: "left",
      flexDirection: props => props.horizontal && "row",
      alignItems: props => props.horizontal && "center",
      justifyContent: props => props.horizontal && "space-between",
    },
    inputRoot: {
      borderColor: theme.palette.black.support,
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: 1,
      height: theme.spacing(6),
      width: props => props.width && theme.spacing(props.width),
    },
    selectRoot: {
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    inputError: {
      borderColor: theme.palette.error.main,
    },
    input: {
      paddingLeft: theme.spacing(2),
      ...theme.typography.body1,
      lineHeight: "16px",
    },
    label: props => {
      return props.hideLabel
        ? visuallyHidden
        : {
            color: props.labelColor
              ? theme.palette[props.labelColor].main
              : theme.palette.black.support,
            marginBottom: !props.horizontal && theme.spacing(1),
            marginRight: props.horizontal && theme.spacing(2),
            marginTop: 0,
            ...theme.typography[props.labelVariant || "button"],
          }
    },
    labelFocused: props => ({
      color:
        (props.labelColor
          ? theme.palette[props.labelColor].main
          : theme.palette.black.support) + " !important",
    }),
    helperText: props => {
      return props.hideHelperText
        ? visuallyHidden
        : {
            color: theme.palette.black.support,
          }
    },
    arrow: {
      pointerEvents: "none",
      position: "absolute",
      right: theme.spacing(2),
    },
  }
})

export default props => {
  const classes = useStyles(props)
  const [error, setError] = useState("")

  const validations = props.validation
    ? Array.isArray(props.validation)
      ? props.validation
      : [props.validation]
    : []

  const validate = uncheckedValue => {
    let errorMessage = ""
    for (let validate of validations) {
      errorMessage = validate(uncheckedValue)
      if (errorMessage) {
        break
      }
    }
    if (error !== errorMessage) {
      setError(errorMessage)
    }
    return !errorMessage
  }

  const handleChange = newValue => {
    validate(newValue)
    if (props.onChange) {
      props.onChange(newValue, error)
    }
  }

  const iconComponent = () => (
    <img src={Chevron} alt={""} className={classes.arrow} />
  )
  const inputComponent = (
    <InputBase
      classes={{
        root: classes.inputRoot,
        input: classes.input,
        error: classes.inputError,
      }}
    />
  )

  return (
    <FormControl
      error={!!error}
      disabled={props.disabled}
      classes={{ root: classes.root }}
    >
      <FormLabel
        htmlFor={props.id}
        classes={{ root: classes.label, focused: classes.labelFocused }}
      >
        {props.label}
      </FormLabel>
      <MuiSelect
        value={props.value}
        native
        onChange={e => {
          handleChange(e.target.value)
        }}
        id={props.id}
        aria-describedby={props.id + "-helper-text"}
        IconComponent={iconComponent}
        input={inputComponent}
        classes={{ select: classes.selectRoot }}
      >
        {props.children}
      </MuiSelect>
      <FormHelperText
        id={props.id + "-helper-text"}
        classes={{ root: classes.helperText }}
      >
        {error}
      </FormHelperText>
    </FormControl>
  )
}
